import { render, staticRenderFns } from "./WashVialSelector.vue?vue&type=template&id=23227aa8&scoped=true&"
import script from "./WashVialSelector.vue?vue&type=script&lang=js&"
export * from "./WashVialSelector.vue?vue&type=script&lang=js&"
import style0 from "./WashVialSelector.vue?vue&type=style&index=0&id=23227aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23227aa8",
  null
  
)

export default component.exports